import React, { useEffect, useState, useRef } from "react";
import PropTypes from "prop-types";
import "./ScrollFade.scss";

const ScrollFade = ({
  children,
  setScrollPosition,
  filterCheckBoxes,
  scrollPosition,
}) => {
  const scrollable = useRef();
  const [scrollSelectPosition, setScrollSelectPosition] = useState({
    left: true,
    right: false,
  });

  const position = (element) => ({
    left: element.target.scrollLeft === 0,
    right:
      element.target.scrollWidth - element.target.scrollLeft ===
      element.target.clientWidth,
  });

  const handleSelectScroll = (e) => {
    setScrollSelectPosition(position(e));
    if (setScrollPosition) setScrollPosition(scrollable.current.scrollLeft);
  };
  useEffect(() => {
    scrollable.current.addEventListener("scroll", handleSelectScroll);
    return () => {
      if (scrollable.current)
        scrollable.current.removeEventListener("scroll", handleSelectScroll);
    };
  }, []);

  useEffect(() => {
    scrollable.current.scrollLeft = scrollPosition;
  }, [filterCheckBoxes, scrollPosition]);

  const leftSelectClass = scrollSelectPosition.left ? "hide-left-fade" : "";
  const rightSelectClass = scrollSelectPosition.right ? "hide-right-fade" : "";

  return (
    <div className="scroll-fade-container">
      <div
        className={`scroll-container ${rightSelectClass} ${leftSelectClass}`}
      >
        <div className="scrollable" ref={scrollable}>
          <div className="scrollable-content">{children}</div>
        </div>
      </div>
    </div>
  );
};

ScrollFade.propTypes = {
  setScrollPosition: PropTypes.func,
  filterCheckBoxes: PropTypes.any,
  scrollPosition: PropTypes.number,
};

export default ScrollFade;
